<template>
    <div class="mt-lg-5 body">
        <div class="pt-2 col-12 col-md-6 col-lg-4">
            <div class="d-flex ml-2 ml-md-5 ml-lg-4 p-lg-2 pt-5 premiumbtn pointer" @click="navToProfileViews">
                <img src="../assets/Back.svg" class="backbtn mt-1" alt="backbtn"/>
                <p class="font20-bold ml-3 mt-4 proximanova">Payment History</p>
            </div>
        </div>
        <!-- <iframe :src="page" id="receiver"
            style="position:relative;z-index:0"
            name="myIframe"
            v-on:load="onLoadIframe" frameborder="0"></iframe> -->
        <div class="row no-gutters body"> 
            <div class="col-12 main-card">
                <div class="row no-gutters">
                    <div class="col-12 middle-background">
                        <div class="col-11 ml-4 mt-2 mb-2">
                            <span class="fontsize16 proximanova ml-lg-4 black fontbold">Current Plan</span>
                        </div>
                        <div class="card ml-3 mr-3 d-flex carddetails">
                            <div class="row no-gutters">
                                <div class="d-flex flex-column col-10 borderright">
                                    <div class="col-12 tablecontent" v-if="currentPlanDetails !== null">
                                        <table>
                                            <tr class="borderbottom">
                                                <th class="fontsm black60 proximanova text-nowrap pl-3">Plan Details</th>
                                                <th class="fontsm black60 proximanova">Price</th>
                                                <th class="fontsm black60 proximanova text-nowrap">Payment Type</th>
                                                <th class="fontsm black60 proximanova text-nowrap">Date of Purchase</th>
                                                <th class="fontsm black60 proximanova text-nowrap">Expires on</th>
                                            </tr>
                                            <tr>
                                                <td class="fontsm black proximanova text-nowrap pl-3">{{currentPlanDetails.planType}}</td>
                                                <td class="fontsm black proximanova">{{currentPlanDetails.amount}}</td>
                                                <td class="fontsm black proximanova text-nowrap">{{currentPlanDetails.cardNetwork}} ****{{currentPlanDetails.cardLastDigits}}</td>
                                                <td class="fontsm black proximanova">{{ currentPlanDetails.startD | moment("DD/MM/YYYY") }}</td>
                                                <td class="fontsm black proximanova">{{ currentPlanDetails.endD | moment("DD/MM/YYYY") }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-12 p-3 text-center" v-else>
                                        <span class="fontbold fontsize16 proximanova">No current Plan available</span>
                                    </div>
                                </div>
                                <div class="col-2 text-center changeplanbtn">
                                    <button class="freetrailbtn ml-2 proximanova" @click="NavToChangePlan">Change plan</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-11 ml-4 mt-4 mb-2 d-flex justify-content-between">
                            <span class="fontsize16 proximanova ml-lg-4 black fontbold">History</span>
                            <div class="d-flex" v-if="subscriptionsList.length > 0">
                                <div class="d-flex pointer">
                                    <img src="../assets/DownloadInvoice.svg" class="img-fluid" alt="download">
                                    <span class="fontsize10 proximanova-bold black receiptlabel ml-2">Rceipt</span>
                                </div>
                                <div class="d-flex ml-4 mr-3 pointer">
                                    <img src="../assets/DownloadInvoice.svg" class="img-fluid" alt="download">
                                    <span class="fontsize10 proximanova-bold black receiptlabel ml-2">Invoice</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-5 mb-4" v-if="pageLoader">
                            <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
                        </div>
                        <div class="card ml-3 mr-3 d-flex carddetails" v-if="!pageLoader && subscriptionsList.length > 0">
                            <div class="tablecontent">
                                <table>
                                    <tr class="borderbottom">
                                        <th class="text-center"><input type="checkbox" class="mt-1 mr-1"></th>
                                        <th class="fontsm black60 proximanova text-nowrap pl-3">Plan Details</th>
                                        <th class="fontsm black60 proximanova">Price</th>
                                        <th class="fontsm black60 proximanova text-nowrap">Payment Type</th>
                                        <th class="fontsm black60 proximanova text-nowrap">Date of Purchase</th>
                                        <th class="fontsm black60 proximanova text-nowrap">Expires on</th>
                                        <th class="fontsm black60 proximanova text-nowrap">Download Receipt</th>
                                        <th class="fontsm black60 proximanova text-nowrap">Download Invoice</th>
                                    </tr>
                                    <tr v-for="(record, index) in subscriptionsList" :key="index">
                                        <td class="text-center"><input type="checkbox" class="mt-1 mr-1"></td>
                                        <td class="fontsm black proximanova text-nowrap pl-3">{{record.planType}}</td>
                                        <td class="fontsm black proximanova">{{record.amount}}</td>
                                        <td class="fontsm black proximanova text-nowrap">{{record.cardNetwork}} ****{{record.cardLastDigits}}</td>
                                        <td class="fontsm black proximanova"><span v-if="record.startD">{{ record.startD | moment("DD/MM/YYYY") }}</span><span v-else></span></td>
                                        <td class="fontsm black proximanova"><span v-if="record.endD">{{ record.endD | moment("DD/MM/YYYY") }}</span><span v-else></span></td>
                                        <td class="black proximanova"><span class="btn downloadbtn fontsm border">Receipt</span></td>
                                        <td class="black proximanova"><span class="btn downloadbtn fontsm border">Invoice</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div v-else class="col-12 pl-3 pr-3 pl-lg-5 pr-lg-5 mx-auto">
                            <no-records-found :message="noRecordsMessage"></no-records-found>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import router from '../router.js'
import wndata from '../js/wn_data.json'
import httppayment from "@/js/http-payment.js";
import httpuserprofile from "../js/http-userprofile.js"
import moment from 'moment'
import cryptoscript from '@/js/cryptoscript.js'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
        NoRecordsFound
    },
    watch: {

    },
    data(){
        return {
            pageLoader : true,
            page : '',
            currentUserProfileId : null,
            currentPlanDetails : null,
            epcustomerId : null,
            subscriptionsList : [],
            transactionsList : [],
            noRecordsMessage : 'No purchase history is present for this user.'
        }
    },
    
    methods: {
        navToProfileViews : function(){
            // router.push({
            //     name : 'profileViews'
            // })
            router.go(-1);
        },
        NavToChangePlan(){
            router.push({
                name : 'Premium'
            })
        },
        // onLoadIframe() {
        //     console.log(this.employeeId);
        //     var receiverWindow = document.getElementById("receiver").contentWindow;
        //     let obj = {
        //         currentUserProfileId : this.currentUserProfileId,
        //         page : 'Purchase History Page'
        //     }
        //     receiverWindow.postMessage(obj, this.page);
        // },
        //this will invoke after getting the transaction details from easypay
        getUserSubscriptionsList(){
            this.subscriptionsList = [];
            var that = this;
            httpuserprofile.get('/userprofile/getSubscriptionListById?profileId='+this.currentUserProfileId)
            .then((response) => {
                console.log(response)
                let listofSubscriptions = response.data;
                if(listofSubscriptions.length > 0){
                    for(var i = 0; i < listofSubscriptions.length; i++){
                        for(var j = 0; j<that.transactionsList.length; j++){
                            if(listofSubscriptions[i].id === that.transactionsList[j].subscriptionId){
                                listofSubscriptions[i].cardLastDigits = that.transactionsList[j].decCardNum;
                                listofSubscriptions[i].cardNetwork = that.transactionsList[j].cardNetwork;
                                that.subscriptionsList.push(listofSubscriptions[i])
                                if(that.currentPlanDetails){
                                    if(that.currentPlanDetails.id === listofSubscriptions[i].id){
                                        that.currentPlanDetails = listofSubscriptions[i]
                                    }
                                }
                            }
                        }
                    }
                }
                console.log("final obj : ", this.subscriptionsList)
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after loading the component
        getCurrentPlanDetails(){
            httpuserprofile.get('/userprofile/getCurrentSubscriptionPlan?profileId='+this.currentUserProfileId+'&status=y')
            .then((response) => {
                if(response.data.length > 0){
                    this.currentPlanDetails = response.data[0];
                }
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after loading the component
        getTransactionsDetails() {
            this.transactionsList = [];
            httppayment.get('/payment/getTransactionDetails?customerId='+this.epcustomerId)
            .then((response) => {
                this.pageLoader = false;
                console.log(response)
                let list = response.data.paymentTransaction;
                if(list.length > 0){
                    for(var i =0; i < list.length; i++){
                        list[i].decCardNum = cryptoscript.decrypt(list[i].cardLastDigits)
                        this.transactionsList.push(list[i])
                    }
                }
                console.log(this.transactionsList)
                this.getUserSubscriptionsList();
            }).catch((e) => {
                console.log(e.response)
                this.pageLoader = false;
            })
        }
    },
    created(){        
        window.scrollTo(0, 0);
        this.page = wndata.easyPayPurchaseHistory
        this.currentUserProfileId = sessionUtils.getUserProfileId()
        // let epcustomerId = localStorage.getItem('epCustomerId')
        let epcustomerId = sessionUtils.getUserProfileId()
        if(epcustomerId !== undefined && epcustomerId !== null){
            this.epcustomerId = epcustomerId;
        }
        this.getCurrentPlanDetails()
        // this.getUserSubscriptionsList()
        this.getTransactionsDetails()
    },
    destroyed() {
    }
}
</script>
<style scoped>
html,
body,
.grid {
    height: 70%;
    width: 100%;
}
/*hide scroll bar */
.body::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.body {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.tablecontent{
    overflow-x:auto;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
    padding: 0 10px 0 10px;
}
.downloadbtn{
    font-size: 12px !important;
}
th, td {
  text-align: left;
  padding: 8px;
}
.viewercards{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.cardsection{
    color: #007AFF;
}
.activeCard{
    color: #007AFF;
}
.card-header1 {
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.card-footer{
    background: white !important;
}
.mouseoveranimate:hover{
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 70%, #000000 100%);
}
.paycard {
    border: none;
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    text-align: left;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.7);
}
.pageloader{
  width: 7%;
  margin-left: 45%;
  margin-top: 5%;
}
.modalbtn {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.receiptlabel{
    padding-top: 7px;
}
.modalbtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.3);
}
.modalbtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.subsec{
    width: 100%;
}
#billingCountry{
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 10px 5px 10px;
    height: 38px;
    background: none;
    color: black;
}
select{
    border: 1px solid rgba(31, 31, 31, 0.1);
    border-radius: 5px;
    font-family: "Proxima Nova Regular";
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.carderror{
    border: 1px solid red;
}
select:focus{
    outline: none;
}

.datepicker{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 39%;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.proximanova{
    margin-top: 2px;
}
.multiselect__tags{
    background: none !important;
}
.multiselect{
    border-bottom: 1px solid rgba(31, 31, 31, 0.1) !important;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border-radius: 5px;
  border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.cardcvv{
    width: 39%;
}
.expairydropdown{
    width: 50%;
}
.paycard2{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 26%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.paycard2:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.cardpayment{
    width: 100%;
}
.hotizonline {
    border-bottom: 1px solid #DDE0E6;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  background: none;
  opacity: 0.3;
  border-radius: 4px;
  padding: 5px 10px;
  /* transition: border 8s; */
}
.starttrailbtn {
    border: none;
    padding: 6px 10px;
    font-size: 16px;
    border-radius: 4px;
}
.paymentoptions {
    background: rgba(240, 242, 245, 0.6);
    border-right: 1px solid rgba(31, 31, 31, 0.1);
    width: 30%;
}
.paymentoptions1{
    background: rgba(240, 242, 245, 0.6);
}
.borderbottom {
    border-bottom: 1px solid rgba(31, 31, 31, 0.1);
}
.cardbody{
    /* border-bottom:  1px solid rgba(31, 31, 31, 0.1); */
    border-radius: 10px;
}
.benifits{
    margin-left: -1em;
}
.benifits li{
    padding: .25em;
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}
.changeplanbtn{
    margin: auto;
}
.card {
  /* border: 3px solid #F0F2F5; */
  border-radius: 10px;
  background-color: #ffffff;
}
.backbtn {
    margin-top: -8px;
}
.premium {
    /* border: 1px solid #FF7676; */
    border: 3px solid #0078ff;
}
.premiumbtn{
    cursor: pointer;
}
.font12Italic {
    font-size: 12px;
    font-family: "Proxima Nova Regulrar";
    font-style: italic;
    font-weight: bold;
    color: rgba(31, 31, 31, 0.8);
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (min-width: 1020px){
    .carddetails{
        margin-left: 3% !important;
        margin-right: 3% !important;
    }
}
</style>

